import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { SortDescriptor } from '@ds';

export type SavedFilterQueryState = {
  filters: Record<string, unknown>;
  page: number;
  itemsPerPage: number;
  searchText: string;
  sortBy?: SortDescriptor;
};

type PageFiltersMemoryStore = {
  pages: Record<string, SavedFilterQueryState>;
  setPageState: (pathname: string, state: SavedFilterQueryState) => void;
  getPageState: (pathname: string) => SavedFilterQueryState | undefined;
  clearPageState: (pathname: string) => void;
  clearAllPages: () => void;
};

export const usePageFiltersMemory = create<PageFiltersMemoryStore>()(
  persist(
    (set, get) => ({
      pages: {},
      setPageState: (pathname, state) =>
        set((prev) => ({
          pages: {
            ...prev.pages,
            [pathname]: state,
          },
        })),
      getPageState: (pathname) => get().pages[pathname],
      clearPageState: (pathname) =>
        set((prev) => {
          const nextPages = { ...prev.pages };
          delete nextPages[pathname];

          return {
            pages: nextPages,
          };
        }),
      clearAllPages: () => set({ pages: {} }),
    }),
    {
      name: 'page-filters-memory',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        pages: state.pages,
      }),
    },
  ),
);
